import { useMutation } from '@apollo/client';
import GET_CURRENT_USER_EVENT_BID from '../queries/getCurrentUserEventBid';
import BID_ON_EVENT from '../queries/bidOnEventMutation';
import REMOVE_BIDDING_ON_EVENT from '../queries/removeBindingOnEventMutation';
import { useCacheNetworkQuery } from '@apollo-internal/hooks/useCacheNetworkQuery';
import { showSuccessToast } from '@shared/services/toastService';

const useEventBidding = (eventId, atmEventView) => {
  const { data: eventBidData, error: eventBidDataError } = useCacheNetworkQuery(
    GET_CURRENT_USER_EVENT_BID,
    {
      variables: { eventId },
      skip: !atmEventView
    }
  );

  const [bidOnEvent, { error: bidOnEventError }] = useMutation(BID_ON_EVENT);

  const [removeBiddingOnEvent, { error: removeBindingOnEventError }] =
    useMutation(REMOVE_BIDDING_ON_EVENT);

  const handleBidOnEvent = async () => {
    await bidOnEvent({ variables: { eventId } });
    showSuccessToast('Your bid has been received.');
  };

  const handleRemoveBid = async () => {
    await removeBiddingOnEvent({ variables: { eventId } });
    showSuccessToast('Your bid has been removed.');
  };

  return {
    canBidForEvent: eventBidData?.currentUserEventBid?.CanBidForEvent,
    isUserBidForEvent: eventBidData?.currentUserEventBid?.BidStatus,
    handleBidOnEvent,
    handleRemoveBid,
    eventBidError: eventBidDataError || bidOnEventError || removeBindingOnEventError
  };
};

export default useEventBidding;
